import React, { FC, JSX } from 'react'

import { FormattedMessage } from 'react-intl'

import { TOP_LOCATION_LIMIT } from 'components/page/Landing/constants'
import {
  LandingColumns,
  LandingRouterLink,
  LandingSection,
  LandingSectionTitle,
} from 'components/page/Landing/LandingView/LandingView.styled'
import { ShowMore } from 'components/page/Landing/LandingView/ShowMore'
import { useLandingParams } from 'components/page/Landing/useLandingParams'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const TopLocationLinksList: FC<{
  locationName: string | JSX.Element
}> = ({ locationName }) => {
  const params = useLandingParams()

  const { locale, seoLocation, seoLocationType, topLocationLinks } =
    useShallowEqualSelector(
      ({
        systemReducer: { locale },
        landingReducer: { seoLocation, seoLocationType, topLocationLinks },
      }) => ({
        locale,
        seoLocation,
        seoLocationType,
        topLocationLinks,
      })
    )

  return (
    <LandingSection>
      <LandingSectionTitle>
        <FormattedMessage
          id="landing.nearest_locations.title"
          values={{ locationName }}
          defaultMessage="Знакомства рядом с {locationName}"
        />
      </LandingSectionTitle>
      <LandingColumns $columns={3}>
        {topLocationLinks.slice(0, TOP_LOCATION_LIMIT).map((topLocation) => (
          <LandingRouterLink
            key={topLocation.url}
            to={
              params.gender
                ? `${topLocation.url}/${params.gender}`
                : topLocation.url
            }
            scrollToTop={true}
          >
            {topLocation.text}
          </LandingRouterLink>
        ))}
        <ShowMore
          locale={locale}
          country={params.country}
          countryId={params.countryId}
          region={params.region}
          regionId={seoLocation!.location.region}
          locationName={locationName}
          locationType={seoLocationType}
        />
      </LandingColumns>
    </LandingSection>
  )
}
